// extracted by mini-css-extract-plugin
export var container = "_fq-0";
export var icon = "_fq-1";
export var text = "_fq-2";